/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Pub_Pro_CtaInputs */

const en_fw_pub_pro_cta = /** @type {(inputs: Fw_Pub_Pro_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See pricing`)
};

const id_fw_pub_pro_cta = /** @type {(inputs: Fw_Pub_Pro_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat harga`)
};

/**
* | output |
* | --- |
* | "See pricing" |
*
* @param {Fw_Pub_Pro_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_pub_pro_cta = /** @type {((inputs?: Fw_Pub_Pro_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Pub_Pro_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_pub_pro_cta(inputs)
	return en_fw_pub_pro_cta(inputs)
});